export default __webpack_public_path__ + "static/Arjun-ffdab6412574418f38a23e2301c24ac50b8a4ea66d1f7a8a1a543fd0ed26b998.svg";